import React, { useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { StartScreen } from "@/components/StartScreen";
import { GameBoard } from "@/components/GameBoard";
import { WinnerScreen } from "@/components/WinnerScreen";

export default function App() {
  const [phase, setPhase] = useState("start"); // start | playing | winner
  const [teams, setTeams] = useState({ team1: "", team2: "" });
  const [winner, setWinner] = useState(null); // { name, color }
  const [gameKey, setGameKey] = useState(0);

  const startGame = ({ team1, team2 }) => {
    setTeams({ team1, team2 });
    setPhase("playing");
  };

  const handleWinner = (w) => {
    setWinner(w);
    setPhase("winner");
  };

  const playAgain = () => {
    setWinner(null);
    setGameKey((k) => k + 1);
    setPhase("playing");
  };

  const newTeams = () => {
    setWinner(null);
    setTeams({ team1: "", team2: "" });
    setPhase("start");
  };

  const exitToStart = () => {
    setWinner(null);
    setPhase("start");
  };

  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      {phase === "start" && <StartScreen onStart={startGame} />}
      {phase === "playing" && (
        <GameBoard
          key={gameKey}
          team1Name={teams.team1}
          team2Name={teams.team2}
          onWinner={handleWinner}
          onExit={exitToStart}
        />
      )}
      {phase === "winner" && winner && (
        <WinnerScreen
          winnerName={winner.name}
          color={winner.color}
          onPlayAgain={playAgain}
          onNewTeams={newTeams}
        />
      )}
    </div>
  );
}
